import { format, startOfMonth, subMonths } from 'date-fns';
import { Download } from 'lucide-react';
import React from 'react';
import { MonthPicker } from '@components/date-picker';
import { Button } from '@components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@components/ui/card';
import { useError } from '../../components/hooks/useError';
import { Api } from '../../core/api';
import { injectTSDI } from '../../core/tsdi';

const TenantOverview = () => {
    const [date, setDate] = React.useState<Date | null>(null);
    const { googleUserAuth, gatewayApiUrl } = injectTSDI(Api);
    const showError = useError();
    const onDownload = async () => {
        if (date) {
            const yearMonth = format(date, 'yyyy-MM');
            try {
                const response = await fetch(
                    `${gatewayApiUrl(
                        'analytics-api'
                    )}/corporate/program/participation/report?year_month=${yearMonth}`,
                    {
                        headers: {
                            authorization: `Bearer ${googleUserAuth?.accessToken}`
                        }
                    }
                );
                const blob = await response.blob();
                const data = new Blob([blob], { type: 'text/csv' });
                const csvURL = window.URL.createObjectURL(data);
                const tempLink = document.createElement('a');
                tempLink.href = csvURL;
                tempLink.setAttribute(
                    'download',
                    `tenant-overview-report-${yearMonth}.csv`
                );
                tempLink.click();
            } catch (e) {
                showError(e);
            }
        }
    };
    return (
        <Card>
            <CardHeader>
                <CardTitle>Tenant Overview</CardTitle>
            </CardHeader>
            <CardContent className="flex flex-wrap items-end gap-3">
                <MonthPicker
                    label="Year and Month"
                    className="w-56"
                    minDate={new Date('2020-04-01')}
                    maxDate={startOfMonth(subMonths(new Date(), 1))}
                    value={date}
                    onChange={setDate}
                    clearable
                />
                <Button disabled={!date} onClick={onDownload}>
                    <Download />
                    Download
                </Button>
            </CardContent>
        </Card>
    );
};

export default TenantOverview;
